module.exports = __webpack_public_path__ + "img/teaser_240x200_bodyqueen.a0e6ee32.jpg";